import { ReactNode } from "react";
import "./error-page-layout.scss";

export default function ErrorPageLayout({
  image,
  action,
  title,
  description,
  mode = "page",
}: {
  image: ReactNode;
  action?: ReactNode;
  title: string;
  description?: string;
  mode?: "dialog" | "page";
}) {
  return (
    <div className={`error-page-layout${mode ? ` ${mode}` : ""}`}>
      <div className="error-page-container">
        <div className="error-page-image">{image}</div>
        <h3 className="error-page-title">{title}</h3>
        {description ? <p className="error-page-description">{description}</p> : null}
        {action ? <div className="error-page-action">{action}</div> : null}
      </div>
    </div>
  );
}
